import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { TableList } from "./chart";
import "../../style.css";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Documents {
  data: {
    collects: {
      status: string;
      departureHour: string;
      route: string;
      routeId: number;
    }[];
    count: number;
  };
}

export const ChartDetailsNotStartedCollectsDocuments = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent} = useContext(DashboardContext);
  const { hasShortToken} = useContext(AuthContext);
  const { id, shortToken, mode } = useParams();

  let routeRoutes: string;
  let routeRoutesAll: string;
  const [routes, setRoutes] = useState<Documents["data"]>({
    collects: [{ status: "", departureHour: "", route: "", routeId: 0 }],
    count: 0,
  });
  const [empty, setEmpty] = useState<string>("");
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/documents/collects?graphic_id=chartDetailsNotStartedCollectsDocuments&short_token=${shortToken}&screen_id=${id}`;
    routeRoutesAll = `/documents/collects?graphic_id=numbersDayCollectsDocumentsNotStarted&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/documents/collects?graphic_id=chartDetailsNotStartedCollectsDocuments&screen_id=${id}`;
    routeRoutesAll = `/documents/collects?graphic_id=numbersDayCollectsDocumentsNotStarted&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return Promise.all([api.get(routeRoutes), api.get(routeRoutesAll)])
      .then(([routes, routesAll]: [Documents, Documents]) => {
        if (routesAll.data.count !== 0 && routes.data.count === 0) {
          setEmpty("Não existem horários limite de saída cadastrados");
        } else {
          setRoutes(routes.data);
        }
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-details-not-started-collects-documents" className="h100">
      {!empty ? (
        <TableList data={routes} />
      ) : (
        <div className="text-center">
          <HeaderComponent
            title={"Rotas Com Coletas - Detalhe"}
            id="chart-details-not-started-collects-documents"
          />
          <div
            style={{ fontSize: "1.4em", marginTop: "20px" }}
            className="pt-1 font-weight-bold number-item component-content"
          >
            {empty}
          </div>
        </div>
      )}
    </div>
  ) : (
    <LoadingGraphics />
  );
};
